export class LoginModelRequest {
    "username": String;
    "password": String;
    "deviceToken": String;
    "platform": "WEB";
    "roleId": Number
}